// extracted by mini-css-extract-plugin
export default {"container":"accessDenied_container__R14K1","info":"accessDenied_info__E45om","warningIcon":"accessDenied_warningIcon__t99-D","warningText":"accessDenied_warningText__Lh-vK"};